import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/components/HomePage.vue';
import MenusPageQr from '@/components/MenusPageQr.vue';
import ContactsPageQr from '@/components/ContactsPageQr.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/menus',
    name: 'Menus',
    component: MenusPageQr
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: ContactsPageQr
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
